var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetworkTrustedPartners(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4994 33.3475C48.5345 36.8243 47.3606 40.2052 45.1786 42.9122C42.9966 45.6192 39.9419 47.4842 36.5369 48.1881C33.132 48.892 29.5882 48.3911 26.5117 46.7712C23.4352 45.1513 21.017 42.5129 19.6706 39.3072C18.3242 36.1015 18.1333 32.5276 19.1304 29.1968C20.1276 25.8659 22.251 22.9849 25.1374 21.0464C28.0239 19.1079 31.4941 18.2324 34.9546 18.5695C38.4152 18.9066 41.6512 20.4354 44.1092 22.8946C46.8957 25.6623 48.4739 29.4201 48.4994 33.3475Z",
    fill: "#104145",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 38.4984C36.2614 38.4984 38.5 36.2598 38.5 33.4984C38.5 30.737 36.2614 28.4984 33.5 28.4984C30.7386 28.4984 28.5 30.737 28.5 33.4984C28.5 36.2598 30.7386 38.4984 33.5 38.4984Z",
    fill: "#F9F7F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9993 46.0013C25.9993 44.0122 26.7895 42.1046 28.196 40.698C29.6025 39.2915 31.5102 38.5013 33.4993 38.5013C35.4884 38.5013 37.3961 39.2915 38.8026 40.698C40.2091 42.1046 40.9993 44.0122 40.9993 46.0013",
    fill: "#F9F7F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0001 16C58.7615 16 61.0001 13.7614 61.0001 11C61.0001 8.23857 58.7615 6 56.0001 6C53.2387 6 51.0001 8.23857 51.0001 11C51.0001 13.7614 53.2387 16 56.0001 16Z",
    fill: "#104145",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 61.0002C13.7613 61.0002 15.9999 58.7616 15.9999 56.0002C15.9999 53.2388 13.7613 51.0002 10.9999 51.0002C8.23851 51.0002 5.99994 53.2388 5.99994 56.0002C5.99994 58.7616 8.23851 61.0002 10.9999 61.0002Z",
    fill: "#104145",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7493 61.0009C58.2011 61.0009 60.9993 58.2027 60.9993 54.751C60.9993 51.2992 58.2011 48.501 54.7493 48.501C51.2975 48.501 48.4993 51.2992 48.4993 54.751C48.4993 58.2027 51.2975 61.0009 54.7493 61.0009Z",
    fill: "#104145",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 18.4998C15.7017 18.4998 18.5 15.7016 18.5 12.2499C18.5 8.79809 15.7017 5.99988 12.25 5.99988C8.79821 5.99988 6 8.79809 6 12.2499C6 15.7016 8.79821 18.4998 12.25 18.4998Z",
    fill: "#104145",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 44.1252L14.7501 52.2502",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 14.7485L44.1251 22.8735",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.375 50.3752L44.1251 44.1252",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8752 22.8751L16.6252 16.6251",
    stroke: "#104145",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkTrustedPartners);
export default __webpack_public_path__ + "static/media/Network-Trusted-Partners.58784075b75f45ef9842f99ff18e02bc.svg";
export { ForwardRef as ReactComponent };